import { render, staticRenderFns } from "./parcel-list-table-summary.vue?vue&type=template&id=522c2d9e"
import script from "./parcel-list-table-summary.vue?vue&type=script&lang=js"
export * from "./parcel-list-table-summary.vue?vue&type=script&lang=js"
import style0 from "./parcel-list-table-summary.vue?vue&type=style&index=0&id=522c2d9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports